import styled from '@emotion/styled';

import { Button } from '@/components/atoms/Button';

export const Container = styled.div`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[4]};
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const Section = styled.section`
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
    font-family: ${({ theme }) => theme.font.family};

    h2 {
        margin: 0 0 ${({ theme }) => theme.spacing[3]} 0;
        font-size: ${({ theme }) => theme.font.size.large};
    }
`;

export const SectionDescription = styled.p`
    margin: 0 0 ${({ theme }) => theme.spacing[3]} 0;
    color: ${({ theme }) => theme.color.grey500};
`;

export const CredentialList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const CredentialRow = styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme }) => theme.spacing[3]};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
`;

export const CredentialMeta = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const CredentialName = styled.span`
    font-weight: ${({ theme }) => theme.font.weight.medium.toString()};
`;

export const CredentialDetails = styled.span`
    font-size: ${({ theme }) => theme.font.size.small};
    color: ${({ theme }) => theme.color.grey500};
`;

export const EmptyState = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.color.grey500};
    font-style: italic;
`;

export const Actions = styled.div`
    margin-top: ${({ theme }) => theme.spacing[3]};
`;

export const StyledButton = styled(Button)`
    width: fit-content;
`;

export const ErrorText = styled.p`
    color: ${({ theme }) => theme.savory.colors.destructive[500]};
    margin: ${({ theme }) => theme.spacing[2]} 0 0 0;
`;

export const Modal = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
`;

export const ModalCard = styled.div`
    background: ${({ theme }) => theme.color.white100};
    padding: ${({ theme }) => theme.spacing[5]};
    border-radius: ${({ theme }) => theme.radius.main};
    max-width: 480px;
    width: 100%;
`;
